import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFingComponent } from './simple-icons-fing.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFingComponent ],
    exports:      [ SimpleIconsFingComponent ],
    bootstrap:    []
})
export class SimpleIconsFingModule {}
